import {
    Component,
    Input
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

enum TextDisplayTypes {
    text = 'TEXT',
    analysis = 'ANALYSIS'
}

@Component({
    selector: 'agpr-text-display',
    templateUrl: './text-display.component.html',
    styleUrls: ['./text-display.component.scss'],
    standalone: false,
})
export class TextDisplayComponent {
    // we have to change it to a @Input set instead of having the safeText defined in the ngOnInit
    // because sometimes we would change the twigTemplate, and it would not change because ngInit didn't run again
    @Input() set data(data: any | undefined) {
        this._data = data;
        const html = data['type'] === TextDisplayTypes.analysis ? this.addTargetBlankToLinks(this._data.text) : this._data.text;
        this.safeText = this.sanitizer.bypassSecurityTrustHtml(html);
    }
    get data(): any | undefined {
        return this._data;
    }
    _data: any;
    safeText: SafeHtml;

    constructor(private sanitizer: DomSanitizer) {}

    private addTargetBlankToLinks(html: string): string {
        if (!html) {
            return html;
        }

        const container = document.createElement('div');
        container.innerHTML = html;

        container.querySelectorAll('a').forEach((anchor) => {
            anchor.target = '_blank';
            anchor.rel = 'noopener';

        });

        return container.innerHTML;
    }
}
